/**
 * Human names for the raw keys the app sends in analytics properties, so the
 * dashboard never shows `quran_shazam_open` to a person.
 */
const FEATURES = {
  hifz: 'Hifz AI',
  hifz_from_quran: 'Hifz AI (from the Quran)',
  hifz_from_ayah: 'Hifz AI (from an ayah)',
  hifz_surah: 'Hifz AI – locked surah',
  hifz_session: 'Hifz AI – review session',
  hifz_ai_download: 'Hifz AI – model download',
  ask_deenly: 'Ask Deenly',
  hutba: 'Khutbah translation',
  hutba_model_download: 'Khutbah – model download',
  quran_shazam: 'Ayah recognition',
  quran_shazam_open: 'Ayah recognition – verse found',
  dream: 'Dream AI',
  tasbih: 'Tasbih',
  tasbihCounter: 'Tasbih',
  zakat: 'Zakat calculator',
  zakatCalculator: 'Zakat calculator',
  inheritance: 'Inheritance calculator',
  inheritanceCalculator: 'Inheritance calculator',
  hatma: 'Khatm planner',
  hatmaPlanner: 'Khatm planner',
  qibla: 'Qibla',
  qiblaLocator: 'Qibla',
  halal: 'Halal scanner',
  halalScanner: 'Halal scanner',
  prayerPosture: 'Salah posture guide',
  salahPosture: 'Salah posture guide',
  mushafLens: 'Mushaf lens',
  scan: 'Mushaf lens',
  recitation: 'Recitation checker',
  tajweed: 'Tajweed test',
  prayer_times_hero: 'Prayer times card',
  ramadan_banner: 'Ramadan banner',
  quran_audio_download: 'Quran audio download',
  offline_download: 'Offline book download',
  book_rating: 'Book rating',
  home_feed: 'Tab: Home',
  library: 'Tab: Library (Quran & books)',
  mosque_finder: 'Tab: Mosque finder',
  islamic_tools: 'Tab: Tools',
  hutba_listen: 'Khutbah – listen',
  hutba_broadcast: 'Khutbah – broadcast',
  posture: 'Salah posture guide',
  home: 'Tab: Home',
  quran: 'Tab: Quran',
  book: 'Tab: Quran',
  kids: 'Tab: Kids',
  map: 'Tab: Mosques',
  mosques: 'Tab: Mosques',
  tools: 'Tab: Tools',
  more: 'Tab: More',
};

/** Screens as `feature_close` names them (time spent); the rest fall back to FEATURES. */
const SCREENS = {
  quran: 'Quran reader',
  book_reader: 'Book reader',
  book: 'Book contents',
  hadith: 'Hadith',
  quiz: 'Quiz',
  podcast: 'Podcast',
  subscription: 'Premium screen',
  settings: 'Settings',
  home_feed: 'Home feed',
  mushaf_lens: 'Mushaf lens',
  hutba_history: 'Khutbah history',
  ai_models: 'AI models settings',
  quran_awards: 'Quran awards',
};

const PRODUCTS = {
  'com.prayer.premium.monthly': 'Monthly',
  'com.prayer.premium.yearly': 'Yearly',
  'com.prayer.premium.lifetime': 'Lifetime',
};

const SOURCES = {
  onboarding: 'Onboarding',
  main: 'Settings / Premium screen',
  dream: 'Dream AI',
  settings: 'Settings',
  ask_deenly: 'Ask Deenly',
  hutba: 'Khutbah',
  hifz: 'Hifz AI',
  tools: 'Tools',
  banner: 'Home banner',
  unknown: 'Unknown',
};

function prettify(key) {
  if (!key || key === 'unknown') return 'Unknown';
  return String(key)
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/[_-]/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export const featureLabel = (key) => FEATURES[key] || prettify(key);
export const screenLabel = (key) => SCREENS[key] || featureLabel(key);
export const productLabel = (key) => PRODUCTS[key] || prettify(key);
export const sourceLabel = (key) => SOURCES[key] || prettify(key);
